import React from 'react';
import { Slide01Title } from './components/slides/Slide01Title';
import { Slide02Opportunity } from './components/slides/Slide02Opportunity';
import { Slide03HowItWorks } from './components/slides/Slide03HowItWorks';
import { Slide04Proof } from './components/slides/Slide04Proof';
import { Slide05Library } from './components/slides/Slide05Library';
import { Slide06Value } from './components/slides/Slide06Value';
import { Slide07Why } from './components/slides/Slide07Why';
import { Slide08NextSteps } from './components/slides/Slide08NextSteps';
export function App() {
  return <div className="bg-background min-h-screen w-full selection:bg-accent-purple/30 selection:text-white" data-id="element-0">
      <main className="flex flex-col w-full" data-id="element-1">
        <Slide01Title data-id="element-2" />
        <Slide02Opportunity data-id="element-3" />
        <Slide03HowItWorks data-id="element-4" />
        <Slide04Proof data-id="element-5" />
        <Slide05Library data-id="element-6" />
        <Slide06Value data-id="element-7" />
        <Slide07Why data-id="element-8" />
        <Slide08NextSteps data-id="element-9" />
      </main>
    </div>;
}